export const environment = {
  baseUrl : "https://ft.k12studentinsurance.com/FastTrackAPI/api/",
  //baseUrl : "https://ctprod01.hsri.com/FastTrackAPI/api/",
  msalConfig: {
    auth: {
     clientId: 'c0bfaf37-9028-4328-b62a-974e470ee51a',
     authority: 'https://login.microsoftonline.com/f1289cc5-8456-4f28-8eab-700d1300fc5d/', //tenant id
     knownAuthorities: 'login.microsoftonline.com',
     //redirecturi: 'https://ctprod01.hsri.com/FastTrack',
     redirecturi: 'https://ft.k12studentinsurance.com/FastTrack',
     logouturi: 'https://login.microsoftonline.com/common/oauth2/v2.0/logout'
    }
  },

  apiConfig: {
    scopes: ['user.read'],
    uri: 'https://graph.microsoft.com/v1.0/me',
    ftScopes: ['https://673hsrik12ft.hsri.com/FastTrack/FastTrack.write'],
    ftUri: '/api/*'
  }
};
